import React, { useEffect, useRef, useState } from "react";
import "./Invoice.css";
import InvoiceDocument, { invoiceNumber } from "./InvoiceDocument";
import Spinner from "../../Spinner";
import { downloadElementAsPdf } from "../../../utils/htmlToPdf";

/**
 * "View Invoice" opens the bill on screen — the button used to be inert — with
 * the same document available as a PDF. The invoice is built from the
 * appointment the list already holds; there is no invoice endpoint to call.
 */
const InvoiceModal = ({ appointment, onClose, onError }) => {
  const invoiceRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);

    // The bookings list behind the overlay must not scroll under the finger.
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  const onClickDownload = async () => {
    setDownloading(true);
    try {
      await downloadElementAsPdf(
        invoiceRef.current,
        `${invoiceNumber(appointment)}.pdf`,
      );
    } catch (error) {
      console.error(error);
      onError?.("Could not download the invoice. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="invoice_overlay" onClick={onClose} role="presentation">
      <div
        className="invoice_sheet"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Invoice"
      >
        <div className="invoice_sheet_head">
          <span>Invoice</span>
          <button
            type="button"
            className="invoice_close_btn"
            onClick={onClose}
            aria-label="Close invoice"
          >
            ×
          </button>
        </div>

        <div className="invoice_sheet_body">
          <InvoiceDocument appointment={appointment} ref={invoiceRef} />
        </div>

        <div className="invoice_sheet_actions">
          <button type="button" className="invoice_secondary_btn" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="invoice_primary_btn"
            onClick={onClickDownload}
            disabled={downloading}
          >
            {downloading ? <Spinner color="#ffffff" /> : "Download PDF"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceModal;
